import React from 'react';

export default function Spinner({ size = '2xl' }) {
  return (
    <div className="animate-spin">
      <i className={`bi bi-arrow-repeat text-${size} text-gray-400 mb-4`}></i>
    </div>
  );
}
